import { render, staticRenderFns } from "./importToCreateOrder.vue?vue&type=template&id=31ed5218&scoped=true&"
import script from "./importToCreateOrder.vue?vue&type=script&lang=js&"
export * from "./importToCreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./importToCreateOrder.vue?vue&type=style&index=0&id=31ed5218&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ed5218",
  null
  
)

component.options.__file = "importToCreateOrder.vue"
export default component.exports